export default __webpack_public_path__ + "static/media/AppealGSTTemplate.2b1de950.xlsx";